<template>
	<div class="filter-status filter">
		<div class="themName">{{themName}}:</div>
		<span class="themlis hovertext" :class="[defaultValue == `${item.uuid}` ?selected: '']" @click="seletedF(item.uuid)" v-for="item in list" :key="item.uuid">{{item.name}}</span>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				selected:{
					selectedClass:true,
					textColor:true,
					borderColor:true
				},
				isSelected: '',
				value1:'',
				molist:[
					{
						uuid:'all',
						name:'全部'
					}
				]
			}
		},

		props:{
			themName:{
				type:String,
				default:'状态'
			},
			list:{
				type:Array,
				default:()=>{[]}
			},
            defaultValue:{
			    type:String|Number,
				default:''
			}

		},
		mounted(){
			// this.isSelected = this.list[0].uuid
		},
		methods: {
			seletedF(val) {
				this.isSelected = val
				this.$emit('changeVal',{'type':val,'val':null})
			},
			timeChange(val) {
				
				this.$emit('changeVal',{'type':this.isSelected,'val':val})
			}
		}
	}
</script>

<style lang="less">
	.filter-status {
		font-size: 14px;
		// margin-top: 10px;
		display: flex;
		align-items: center;
        flex-wrap: wrap;
		.themlis {
			// margin-left: 10px;
			    margin: 0px 5px;
			display: inline-block;
			padding: 0px 5px;
			height: 24px;
			line-height: 22px;
			border: 1px solid transparent;
			border-radius: 5px;
            cursor: pointer;

			&.selectedClass {
				// color: #41a0ff;
				border: 1px solid #41a0ff;
				border-radius: 5px;
			}
		}

		.themName {
			color: @huiseColor;
			height: 40px;
			line-height: 40px;
		}
	}
	.filter{
		margin-top: 0px!important;
	}
</style>
